import { BillingSummary, formatCurrency, formatDateISO } from "shared";
import { useScrollToHashOnLoad } from "../../hooks/useScrollToHashOnLoad";
import { Button } from "../Button";
import { Row } from "../Row";
import styles from "./BillingPaymentOld.module.scss";
import { useCountry, useUrls } from "../../app/Providers/AppContext";
import cx from "clsx";
import { Divider } from "../Divider";

export type BillingPaymentV1Props = { billing: BillingSummary };

/** Renders the "Billing and Payment" region */
export const BillingPaymentOld = ({ billing }: BillingPaymentV1Props) => {
  const urls = useUrls();
  const managePaymentsUrl = urls.billing.managePayments;
  const country = useCountry();
  useScrollToHashOnLoad("billing");

  // Returns a single string for displaying amount due info
  function getAmountDue(amount: number, dueDateISO: string | null) {
    const amountDue = formatCurrency(amount, { country });
    return amount > 0 && dueDateISO
      ? `${amountDue} on ${formatDateISO(dueDateISO)}`
      : amountDue;
  }

  if (billing.status === "error" || billing.status === "unavailable") {
    return (
      <>
        <dl className={styles.unavailable}>
          <Row
            className={cx(styles.buttonPadding, styles.noWrap)}
            label="Make a payment, view billing statements, and more."
            showDivider={false}
          >
            <Button
              className={styles.managePayments}
              href={managePaymentsUrl}
              newTab
            >
              Manage Payments
            </Button>
          </Row>
        </dl>
        <Divider />
      </>
    );
  }

  const { amount, dueDateISO } = billing;
  return (
    <Row label="Total due" hideLabelForAria className={styles.noWrap}>
      {getAmountDue(amount, dueDateISO)}

      {amount > 0 && (
        <Button
          className={styles.payNow}
          href={managePaymentsUrl}
          newTab
          ariaLabel="Pay your bill"
        >
          Pay now
        </Button>
      )}
    </Row>
  );
};
